<template>
  <v-card height="100%" tile>
    <v-row column fill-height>
      <v-col fill-height class="scrollable">
        <v-card-text class="table-container">
          <v-row>
            <v-col class="col-1 back" @click.prevent="$router.back()">
              <v-icon>chevron_left</v-icon>
            </v-col>
            <v-col screen-title>
              <h1>{{ resx.labels.visits }}</h1>
            </v-col>
          </v-row>
          <v-data-table
            :class="{ 'layout-fixed': $vuetify.breakpoint.lgAndUp }"
            :headers="headers"
            :items="history || []"
            :no-data-text="
              firstTimeLoading ? '' : resx.messages.noVisitsAvailable
            "
            :no-results-text="
              firstTimeLoading ? '' : resx.messages.noVisitsFound
            "
            :search="search"
            :sort-desc="true"
            fixed-header
            sort-by="dateOfVisit"
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
          >
            <template v-slot:item.contractorCompany.contractor.name="{ item }">
              <td class="word-wrap">
                {{ item.contractorCompany.contractor.name }}
              </td>
            </template>
            <template v-slot:item.dateOfVisit="{ item }">
              <td>
                <a @click="openDetail(item)">{{
                  item.dateOfVisit | date("short")
                }}</a>
              </td>
            </template>
            <template v-slot:item.comment="{ item }">
              <td class="hidden-sm-and-down">
                <comments :readonly="true" :value="item.comment"></comments>
              </td>
            </template>
            <template v-slot:item.state="{ item }">
              <td class="state" v-if="item.state == 'pending_authorization'">
                {{ resx.labels.pendingAuthorization }}
              </td>
              <td class="state" v-if="item.state == 'active'">
                {{ resx.labels.active }}
              </td>
              <td class="state" v-if="item.state == 'rated'">
                {{ resx.labels.active }}
              </td>
              <td class="state" v-if="item.state == 'authorized'">
                {{ resx.labels.authorized }}
              </td>
            </template>
            <template v-slot:item.actions="{ item }">
              <td class="justify-center layout px-0">
                <v-menu bottom auto>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openDetail(item)">
                      <v-list-item-action>
                        <v-icon color="primary">visibility</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.view
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="item.state == 'authorized' || item.state == 'pending_authorization'"
                      @click="cancelVisit(item)"
                    >
                      <v-list-item-action>
                        <v-icon color="primary">cancel</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.cancel
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="item.state == 'active' || item.state == 'rated'"
                      @click="setEgress(item)"
                    >
                      <v-list-item-action>
                        <v-icon color="primary">check</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.check_out
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-col>
    </v-row>
    <v-navigation-drawer
      id="viewVisitDetail"
      right
      fixed
      clipped
      temporary
      v-model="showDetail"
      :stateless="!showDetail || rateVisit != null"
      width="500"
      style="z-index:100"
      v-click-outside="onClickOutside()"
    >
      <v-row column fill-height>
        <v-col>
          <v-app-bar dark flat color="primary">
            <v-app-bar-nav-icon @click="closeDetail()">
              <v-icon>arrow_back</v-icon>
            </v-app-bar-nav-icon>
            <v-toolbar-title dark>{{
              resx.labels.visitDetail.toUpperCase()
            }}</v-toolbar-title>
          </v-app-bar>
          <v-list two-line>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">perm_contact_calendar</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.contractor
                }}</v-list-item-subtitle>
                <v-list-item-title>{{
                  selectedVisit &&
                    selectedVisit.contractorCompany.contractor.name
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">change_history</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.state
                }}</v-list-item-subtitle>
                <v-list-item-title
                  >{{ selectedVisit && resx.labels[selectedVisit.state] }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">event</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.startDateTimeOfVisit
                }}</v-list-item-subtitle>
                <v-list-item-title class="capitalize">{{
                  selectedVisit &&
                  selectedVisit.dateOfVisit | date("longDate")
                }}</v-list-item-title>
                <v-list-item-title class="capitalize">{{
                  selectedVisit &&
                  selectedVisit.dateOfVisit | date("shortTime")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <hr class="visitors-line" />
            <v-list-item class="visitors">
              <v-list-item-action>
                <v-icon color="primary">subject</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.visitors
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="visitors">
              <v-list-item-action></v-list-item-action>
              <v-list-item-content>
                <visit-details-visitors
                  v-if="selectedVisit"
                  :visit="selectedVisit"
                ></visit-details-visitors>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-col fill-height v-if="selectedVisit && selectedVisit.closedBy">
            <p class="px-4 py-4">{{ selectedVisit.comment }}</p>
          </v-col>
        </v-col>
      </v-row>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
"use strict";

import { mapState } from "vuex";
import moment from "moment";
import { EventBus } from "@/bus";
import companyService from "@/services/CompanyService";
import contractorCompanyService from "@/services/ContractorCompanyService";
import roles from "@/utils/roles";
import constants from "@/utils/constants";
import comments from "@/components/common/comments.vue";
import visitDetailsVisitors from "@/components/views/visits/visit-details-visitors.view.vue";

export default {
  name: "viewVisit",
  async mounted() {
    EventBus.$on("pendingRateSaved", this.updateVisit);
    this.getVisitList();
  },
  components: {
    comments,
    visitDetailsVisitors
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      search: "",
      rateVisit: null,
      selectedVisit: null,
      showDetail: false,
      firstTimeLoading: true,
      closedBy: null,
      headers: [
        {
          text: resx.labels.contractor,
          value: "contractorCompany.contractor.name"
        },
        {
          text: resx.labels.dateStart,
          value: "dateOfVisit"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.comments,
          value: "comment"
        },
        {
          class: "state",
          text: resx.labels.state,
          value: "state"
        },
        {
          align: "center",
          sortable: false,
          text: resx.labels.actions,
          value: "actions"
        }
      ],
      history: null,
      companies: [],
      count: 0,
      value: null,
      filters: this.$store.state.search.contractor.filters,
    };
  },
  destroyed() {
    EventBus.$off("pendingRateSaved", this.updateVisit);
  },
  computed: {
    ...mapState({
      refreshVisits: state => state.refreshes.activateRefresh.refreshed
    })
  },
  watch: {
    refreshVisits() {
      let refreshed = this.$store.state.refreshes.activateRefresh.refreshed;
      if (refreshed == true) {
        this.getVisitList();
      }
    }
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    async getVisitList() {
      if (
        roles.loggedUserHasRoles(this.$store.state.auth.user.roles, [
          this.$store.state.constants.roles.ADMIN,
        this.$store.state.constants.roles.SECURITY,
        this.$store.state.constants.roles.SYS_SUPERVISOR
        ])
      ) {
        this.filters.company = this.$store.state.auth.user.company._id;
        }
        this.companies = await companyService.getCompanies();
        this.history = await companyService.getAllVisitsFromAllContractors(
        this.$store.state.auth.user.company._id
      );
      this.history = this.history.filter(row => row.closedAt == null);
      this.$store.state.refreshes.activateRefresh.refreshed = false;
      this.firstTimeLoading = false;
    },
    async cancelVisit(visit) {
      await contractorCompanyService.informVisitCancel(visit._id, constants.VISIT.cancelled);
      this.history.splice(this.history.indexOf(visit), 1);
    },
    updateVisit(visit) {
      const idx = this.history.findIndex(history => history._id == visit._id);
      if (idx >= 0) {
        this.$set(this.history, idx, visit);
      }
      if (this.selectedVisit) {
        this.$set(this, "selectedVisit", visit);
      }
    },
    registerCheckIn(visit) {
      if (visit.dateOfVisit === null && visit.state === "authorized") {
        visit.dateOfVisit = Date.now();
        visit.state = "active";

        // eslint-disable-next-line
        let foo = companyService.editVisit(
          this.$store.state.auth.user.company._id,
          visit
        );
      }

      if (visit.state === "pending_authorization") {
        alert("debe autorizar");
      }
    },
    async setEgress(visit) {
      visit.endOfVisit = Date.now();
      await companyService.setEgress(visit);
    },
    async openDetail(visit) {
      this.selectedVisit = visit;
      this.showDetail = true;
    },
    async closeDetail() {
      this.selectedVisit = null;
      this.showDetail = false;
    },
    async onClickOutside() {
      if (this.showDetail == false) {
        this.selectedVisit = null;
      }
    },
    duration(visit) {
      if (visit.dateOfVisit && visit.endOfVisit) {
        return moment
          .utc(
            moment
              .duration(
                moment.duration(
                  moment(visit.endOfVisit)
                    .add(1, "minute")
                    .diff(visit.dateOfVisit)
                ),
                "minutes"
              )
              .asMilliseconds()
          )
          .format("HH:mm");
      } else {
        return "";
      }
    },
    // eslint-disable-next-line
    customFilter(items, searchText, filter) {
      const cf = new this.$MultiFilters(items, this.filters);

      cf.registerFilter("company", (companyId, items) => {
        if (!companyId || companyId.trim() === "") return items;
        return items.filter(i => {
          return companyId == i.company;
        }, companyId);
      });

      cf.registerFilter("dateFrom", function(dateFrom, items) {
        if (!dateFrom || dateFrom.trim() === "") return items;
        return items.filter(row => {
          return (
            row.dateOfVisit &&
            moment(row.dateOfVisit).isSameOrAfter(moment(dateFrom))
          );
        }, dateFrom);
      });

      cf.registerFilter("dateTo", function(dateTo, items) {
        if (!dateTo || dateTo.trim() === "") return items;
        return items.filter(row => {
          return (
            row.endOfVisit &&
            moment(row.endOfVisit).isSameOrBefore(moment(dateTo))
          );
        }, dateTo);
      });

      cf.registerFilter("search", (search, items) => {
        if (!search || search.trim() === "") return items;

        search = search.toString().toLowerCase();
        return items.filter(i =>
          this.headers.some(j =>
            // eslint-disable-next-line
            j.value && _.get(i, j.value) ? _.get(i, j.value).toString().toLowerCase().includes(search) : false
          )
        );
      });

      const result = cf.runFilters();
      this.count = result.length;
      return result;
    }
  }
};
</script>

<style lang="scss">
#viewVisitDetail {
  .v-icon.notranslate.material-icons.theme--light.primary--text {
    padding-left: 24px;
  }
  .v-list.v-sheet.theme--light.v-list--two-line {
      padding-left: 0px;
  }
  .visit-motive {
    .v-list__tile {
      height: auto;
      max-height: 96px;
    }
    .v-list__tile__title {
      white-space: normal;
      overflow: initial;
      text-overflow: initial;
      height: auto;
      max-height: 96px;
    }
  }
  .container {
    padding: 0 40px 0 12px;
  }
  .v-list-item {
    padding: 0 0px;
  }
  .row.datetime-layout .col {
    padding-top: 0px;
  }
  .visitors-line {
    margin: 12px 34px;
    border-width: 1px;
    border-bottom: 0px;
    border-color: #eee;
  }
  .v-select__selections {
    max-height: 30px;
  }
  .v-text-field {
    margin-top: 0px;
  }
}

.datetime-layout {
  max-height: 25px;
}

.v-list--two-line .v-list__tile {
  height: 57px;
}

.count-items {
  margin-top: 20px;
  min-width: 100px;
  text-align: right;
  z-index: 5;
}

.back {
  cursor: pointer;
}

.back i.v-icon {
  margin-bottom: 0px;
  font-size: 75px;
}

.screen-title {
  margin-top: 25px;
  padding-right: 8%;
}

.visitors .v-list__tile {
  height: auto;
}

.table-container {
  padding-top: 0;

  h1 {
    font-size: 1.25rem;
    padding-top: 12px;
  }

  .back {
    padding: 0;
    max-width: 68px;
  }
}
</style>
